import { Injectable } from "@angular/core";
import {
  AlertController,
  LoadingController,
  ModalController,
  ToastController,
} from "ionic-angular";
import { Loading } from "ionic-angular/components/loading/loading";

@Injectable()
export class UiService {
  constructor(
    public alertCtrl: AlertController,
    public modalCtrl: ModalController,
    public loadingCtrl: LoadingController,
    public toastCtrl: ToastController,
  ) {}

  // Alert/Prompt
  createAlert(
    title: string = "Harmonised",
    message: string,
    inputs?: any[],
    buttons?: any[],
  ) {
    if (!buttons || !buttons.length) {
      buttons = ["OK"];
    }

    return this.alertCtrl.create({
      title: title,
      subTitle: message,
      inputs: inputs,
      buttons: buttons,
    });
  }

  showAlert(
    title: string = "Harmonised",
    message: string,
    inputs?: any[],
    buttons?: any[],
  ) {
    if (!buttons || !buttons.length) {
      buttons = ["OK"];
    }

    let alert = this.createAlert(title, message, inputs, buttons);

    return alert.present();
  }

  // Modal
  showModal(page: any, params: any) {
    let modal = this.modalCtrl.create(page, params);

    return modal.present();
  }

  // Loader
  createLoader(options: any = null): Loading {
    // @ts-ignore
    return this.loadingCtrl.create(
      Object.assign(
        {},
        {
          dismissOnPageChange: true,
        },
        options || {},
      ),
    );
  }

  showLoader(): Promise<Loading> {
    let loader = this.createLoader();

    return loader.present().then(() => {
      return loader;
    });
  }

  // Toast
  createToast(
    message: string,
    duration: number = 3000,
    position: string = "bottom",
  ) {
    return this.toastCtrl.create({
      message: message,
      duration: duration,
      position: position,
    });
  }

  showToast(
    message: string,
    duration: number = 3000,
    position: string = "bottom",
  ) {
    const toast = this.createToast(message, duration, position);

    return toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/providers/ui.ts